import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import UserContainer from 'components/user/container/UserContainer';
import { Header } from 'components/atoms/Header/Header';
import Table from 'components/table/Table';
import { formatUnixDate } from 'controls/utils';
import { Language } from 'language/Language';
import { orderDetailsStrings } from './strings';
import { getOrder } from './getData';

const OrderDetails = () => {
  const history = useHistory();
  const { location } = history;
  const id = location.search.split('?')[1];
  const { orders } = useSelector((state) => state);
  const order = orders ? getOrder(orders, id) : null;
  const language = Language();

  useEffect(() => {
    if (id === undefined) {
      history.push(language === 'japan' ? '/ja/私のアカウント' : '/my-account');
    }
  }, [history, id, language]);

  return (
    <UserContainer>
      <div style={{ width: '100%' }}>
        {order
          ? (
            <>
              <p>{`${orderDetailsStrings[language].order} ${order.orderID} ${orderDetailsStrings[language].placed} ${formatUnixDate(order.createdAtUnixEpoch)} ${orderDetailsStrings[language].currency} ${order.status}.`}</p>
              <Header text={orderDetailsStrings[language].title} />
              <Table>
                <>
                  <Table.Header headers={[orderDetailsStrings[language].product, orderDetailsStrings[language].total]} />
                  <Table.Content>
                    <>
                      <div className='table-row'>
                        <div className='table-content__item table-item__long'>
                          <p>{order.entitlements[0] ? order.entitlements[0].name : '360 WalkMix Creator™'}</p>
                          <p>{!order.entitlements[0] && "this order don't have a entitlement"}</p>
                        </div>
                        <div className='table-content__item table-item__long'>
                          <h3>{`$${order.total}`}</h3>
                        </div>
                      </div>
                      <div className='table-row'>
                        <div className='table-content__item'>
                          <h3>{orderDetailsStrings[language].pay}</h3>
                        </div>
                        <div className='table-content__item'>
                          <h3>PADDLE</h3>
                        </div>
                      </div>
                      <div className='table-row'>
                        <div className='table-content__item'>
                          <h3>{orderDetailsStrings[language].TOTAL}</h3>
                        </div>
                        <div className='table-content__item'>
                          <h3>{`$${order.total}`}</h3>
                        </div>
                      </div>
                    </>
                  </Table.Content>
                </>
              </Table>
              <Header text={orderDetailsStrings[language].info} />
              <div style={{ border: '1px solid white', padding: '10px' }}>
                <p>{order.user.name}</p>
                <p>
                  <Icon name='mail' size='small' />
                  {order.user.email}
                </p>
              </div>
            </>
          )
          : (<p>No order has been made yet.</p>)}
      </div>
    </UserContainer>
  );
};

export default OrderDetails;
